import ReactMarkdown from "react-markdown";
import styles from "./MarkdownRenderer.module.css";
import remarkGfm from "remark-gfm"

interface MarkdownRendererProps {
  markdown: string;
}

function escapeLeadingNumberedLines(markdown: string): string {
  return markdown.replace(/^(\d+)\. /gm, '$1\\. ');
}

export function MarkdownRenderer({ markdown }: MarkdownRendererProps) {
  const safeMarkdown = escapeLeadingNumberedLines(markdown);

  return (
    <div className={styles.markdownContent}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ node, ...props }) => <div {...props} />,
        }}
      >
        {safeMarkdown}
      </ReactMarkdown>
    </div>
  );
}